module.exports = __webpack_public_path__ + "static/media/smile.a9eab427.png";